export interface Film {
  id: string;
  title: string;
  year: number;
  region: string;
  genre: string;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  tags: string[];
  views: string;
  summary: string;
  cover: string;
}

export const films: Film[] = [
  {
    id: "f01",
    title: "静水之年",
    year: 2024,
    region: "日本",
    genre: "家庭伦理",
    rating: 8.7,
    duration: "118 分钟",
    director: "渡边慎一",
    cast: ["小林夏帆", "中村隆", "高桥由纪"],
    tags: ["温情", "母女关系", "慢节奏"],
    views: "128.6 万",
    summary: "母亲在湖边小镇独居三十年，直到女儿带着一纸诊断回到老屋。两人在整理旧物的过程中，重新面对当年那次不告而别。影片以极克制的镜头，讲述原谅如何一寸一寸发生。",
    cover: "https://readdy.ai/api/search-image?query=a%20patient%20middle%20aged%20woman%20sitting%20alone%20on%20a%20wooden%20dock%20beside%20a%20calm%20misty%20lake%20at%20dawn%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-01&orientation=portrait",
  },
  {
    id: "f02",
    title: "长夜将尽",
    year: 2023,
    region: "韩国",
    genre: "社会现实",
    rating: 8.5,
    duration: "126 分钟",
    director: "金敏俊",
    cast: ["李在勋", "朴秀珍", "崔民政"],
    tags: ["现实主义", "小人物", "深夜"],
    views: "96.2 万",
    summary: "一名代驾司机在连续七个夜班里，接连载到同一批彼此有牵连的乘客。他从后视镜里拼凑出一桩无人愿意提起的往事，也照见了自己。",
    cover: "https://readdy.ai/api/search-image?query=a%20solitary%20male%20driver%20seen%20through%20a%20rain%20streaked%20car%20window%20at%20night%20with%20city%20lights%20bokeh%20outside%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-02&orientation=portrait",
  },
  {
    id: "f03",
    title: "母亲的第二个春天",
    year: 2022,
    region: "中国",
    genre: "家庭伦理",
    rating: 8.2,
    duration: "109 分钟",
    director: "陈望舒",
    cast: ["周静秋", "林兆", "苏念"],
    tags: ["再婚", "代际冲突", "理解"],
    views: "74.9 万",
    summary: "父亲离世三年后，母亲提出想再婚。三个子女各有各的理由反对，却没有人先问一句她想要什么。一场家宴，把这家人几十年没说出口的话摊在了桌上。",
    cover: "https://readdy.ai/api/search-image?query=a%20dignified%20older%20woman%20smiling%20gently%20in%20a%20warm%20sunlit%20dining%20room%20with%20family%20photos%20on%20the%20wall%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-03&orientation=portrait",
  },
  {
    id: "f04",
    title: "归途列车",
    year: 2023,
    region: "中国",
    genre: "都市情感",
    rating: 8.4,
    duration: "132 分钟",
    director: "顾南",
    cast: ["沈知远", "叶light", "吴桐"],
    tags: ["亲子", "异乡", "春运"],
    views: "88.3 万",
    summary: "一对在外打拼的父母，把女儿留在老家整整十年。又一次春运，他们决定接女儿回城的这一次，却发现孩子早已把别人当成了家。",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20girl%20pressing%20her%20face%20to%20a%20train%20window%20as%20countryside%20rushes%20past%20at%20dusk%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-04&orientation=portrait",
  },
  {
    id: "f05",
    title: "沉默的河",
    year: 2024,
    region: "日本",
    genre: "悬疑伦理",
    rating: 8.9,
    duration: "141 分钟",
    director: "白石凉子",
    cast: ["佐藤绪", "山田稔", "井上真"],
    tags: ["反转", "小镇", "双重真相"],
    views: "156.8 万",
    summary: "小镇上的一桩旧案被重新翻出，唯一的目击者却始终不肯开口。当年负责案件的退休警员发现，沉默也许才是唯一能够保护某个人的方式。",
    cover: "https://readdy.ai/api/search-image?query=a%20lone%20detective%20standing%20on%20a%20stone%20bridge%20over%20a%20dark%20river%20in%20fog%20at%20blue%20hour%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-05&orientation=portrait",
  },
  {
    id: "f06",
    title: "父亲的旧手表",
    year: 2021,
    region: "中国",
    genre: "家庭伦理",
    rating: 8.1,
    duration: "102 分钟",
    director: "周牧",
    cast: ["何建国", "方云", "罗小舟"],
    tags: ["父子", "遗产", "和解"],
    views: "63.4 万",
    summary: "父亲去世后只留下一只停摆的旧手表。修理它的过程，让一向倔强的儿子一点点读懂了父亲那些沉默的年份。",
    cover: "https://readdy.ai/api/search-image?query=a%20weathered%20man%20holding%20an%20old%20wristwatch%20near%20a%20quiet%20workshop%20window%20with%20dust%20in%20the%20light%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-06&orientation=portrait",
  },
  {
    id: "f07",
    title: "陌上花开",
    year: 2023,
    region: "中国",
    genre: "文艺剧情",
    rating: 8.3,
    duration: "115 分钟",
    director: "苏离",
    cast: ["温茉", "江屿", "白露"],
    tags: ["乡村", "留守", "四季"],
    views: "57.1 万",
    summary: "一位年轻的乡村教师在空心的村庄里坚守了七个春天。她等的不只是孩子们长大，还有一个迟迟没有兑现的承诺。",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20woman%20in%20a%20light%20dress%20standing%20in%20a%20wildflower%20field%20with%20rolling%20hills%20at%20golden%20hour%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-07&orientation=portrait",
  },
  {
    id: "f08",
    title: "第七个房客",
    year: 2022,
    region: "韩国",
    genre: "悬疑伦理",
    rating: 8.6,
    duration: "124 分钟",
    director: "李在勋",
    cast: ["郑河", "孙映", "裴成宇"],
    tags: ["群像", "合租", "秘密"],
    views: "112.5 万",
    summary: "一栋老式合租屋先后住进七个房客，每个人都带着不愿被翻开的过去。当第六个人的行李箱被打开，整栋房子的秩序开始崩塌。",
    cover: "https://readdy.ai/api/search-image?query=a%20dim%20narrow%20staircase%20of%20an%20old%20shared%20house%20lit%20by%20a%20single%20bulb%2C%20doors%20slightly%20ajar%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-08&orientation=portrait",
  },
  {
    id: "f09",
    title: "潮汐之间",
    year: 2024,
    region: "法国",
    genre: "社会现实",
    rating: 8.8,
    duration: "137 分钟",
    director: "皮埃尔·布瓦",
    cast: ["克莱尔·莫罗", "吕克·庞", "安娜·维"],
    tags: ["劳工", "海边", "尊严"],
    views: "91.7 万",
    summary: "海边小镇的罐头厂即将关闭，靠它养家的女工们决定自己接管工厂。她们争的不只是一份工资，更是被听见的权利。",
    cover: "https://readdy.ai/api/search-image?query=a%20group%20of%20determined%20women%20walking%20along%20a%20windy%20harbor%20at%20low%20tide%20with%20fishing%20boats%20behind%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-09&orientation=portrait",
  },
  {
    id: "f10",
    title: "我们仨的夏天",
    year: 2023,
    region: "中国",
    genre: "家庭伦理",
    rating: 8.0,
    duration: "98 分钟",
    director: "林知夏",
    cast: ["顾漫", "徐亦", "小南"],
    tags: ["成长", "三兄妹", "夏天"],
    views: "52.8 万",
    summary: "父母出差的那个夏天，十六岁的姐姐要独自照顾两个年幼的弟弟。一个关于承担、争吵和悄悄长大的故事。",
    cover: "https://readdy.ai/api/search-image?query=three%20siblings%20sitting%20on%20a%20sunlit%20doorstep%20of%20an%20old%20country%20house%20in%20summer%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-10&orientation=portrait",
  },
  {
    id: "f11",
    title: "灰烬里的信",
    year: 2022,
    region: "意大利",
    genre: "社会现实",
    rating: 8.7,
    duration: "129 分钟",
    director: "马泰奥·里",
    cast: ["朱莉娅·罗", "马尔科·德", "伊莎·贝"],
    tags: ["历史", "书信", "寻亲"],
    views: "68.9 万",
    summary: "一位老邮差临终前交出一批从未投递的信。年轻的女记者循着地址寻找收信人，却走进了一座城市被掩埋的记忆。",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20woman%20reading%20old%20letters%20by%20a%20fireplace%20with%20ash%20and%20embers%20glowing%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-11&orientation=portrait",
  },
  {
    id: "f12",
    title: "门口的月光",
    year: 2024,
    region: "中国",
    genre: "都市情感",
    rating: 8.2,
    duration: "106 分钟",
    director: "陈望舒",
    cast: ["许清和", "沈拾", "罗一川"],
    tags: ["邻里", "都市孤独", "温情"],
    views: "61.3 万",
    summary: "独居的退休教师和对门刚搬来的年轻租客，因为一盏总是忘记关的楼道灯而相识。两个孤独的人，慢慢成了彼此的灯。",
    cover: "https://readdy.ai/api/search-image?query=an%20elderly%20man%20standing%20at%20an%20apartment%20doorway%20lit%20by%20moonlight%20with%20warm%20hallway%20glow%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-12&orientation=portrait",
  },
  {
    id: "f13",
    title: "逆流的鱼",
    year: 2021,
    region: "日本",
    genre: "文艺剧情",
    rating: 8.5,
    duration: "121 分钟",
    director: "渡边慎一",
    cast: ["森川透", "桥本奈", "石井凉"],
    tags: ["梦想", "父子", "小镇"],
    views: "45.6 万",
    summary: "渔港长大的少年执意要去城市学音乐，父亲则希望他继承渔船。一次远航，让两代人在同一片海上第一次真正交谈。",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20fisherman%20standing%20knee%20deep%20in%20shallow%20sea%20water%20under%20a%20vast%20cloudy%20sky%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-13&orientation=portrait",
  },
  {
    id: "f14",
    title: "昨日重现",
    year: 2023,
    region: "韩国",
    genre: "都市情感",
    rating: 8.4,
    duration: "113 分钟",
    director: "金敏俊",
    cast: ["朴秀珍", "姜到贤", "尹世罗"],
    tags: ["重逢", "旧友", "遗憾"],
    views: "79.2 万",
    summary: "高中同学会上，两个当年不告而别的人再次遇见。他们试着把二十年前那个没说出口的解释，重新说一遍。",
    cover: "https://readdy.ai/api/search-image?query=two%20adults%20sitting%20across%20a%20small%20cafe%20table%20at%20dusk%20with%20rain%20on%20the%20glass%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-14&orientation=portrait",
  },
  {
    id: "f15",
    title: "十二月的信使",
    year: 2024,
    region: "北欧",
    genre: "文艺剧情",
    rating: 8.3,
    duration: "117 分钟",
    director: "英格丽·森",
    cast: ["艾拉·诺", "马茨·林", "索菲·格"],
    tags: ["冬季", "孤独", "救赎"],
    views: "49.4 万",
    summary: "极夜来临前，一名沉默的护林员开始替陌生人往林间投递没有署名的信。收信的人一个个出现，他也终于面对自己掩埋多年的事。",
    cover: "https://readdy.ai/api/search-image?query=a%20lone%20figure%20in%20a%20thick%20coat%20walking%20through%20a%20snowy%20pine%20forest%20under%20soft%20winter%20light%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-15&orientation=portrait",
  },
  {
    id: "f16",
    title: "屋檐下的春天",
    year: 2022,
    region: "中国",
    genre: "家庭伦理",
    rating: 8.1,
    duration: "104 分钟",
    director: "周牧",
    cast: ["方云", "梁栋", "陆小曼"],
    tags: ["婆媳", "旧屋", "日常"],
    views: "58.7 万",
    summary: "老屋要拆了，婆婆和儿媳在最后一个春天里一起收拾四十年的家当。她们曾经谁也看不惯谁，却在旧物里找到了同一个人的影子。",
    cover: "https://readdy.ai/api/search-image?query=two%20women%20sorting%20old%20belongings%20in%20the%20courtyard%20of%20an%20old%20chinese%20house%20in%20spring%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-16&orientation=portrait",
  },
  {
    id: "f17",
    title: "无声告白",
    year: 2023,
    region: "中国",
    genre: "悬疑伦理",
    rating: 8.6,
    duration: "127 分钟",
    director: "苏离",
    cast: ["沈拾", "温茉", "江屿"],
    tags: ["家庭秘密", "心理", "反转"],
    views: "103.1 万",
    summary: "一个看似完美的中产家庭，在女儿留下一段录音后彻底瓦解。每个成员都在说谎，而真相藏在谁都没有留意的那句日常里。",
    cover: "https://readdy.ai/api/search-image?query=a%20well%20dressed%20family%20standing%20stiffly%20in%20a%20large%20dim%20living%20room%20with%20cold%20light%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-17&orientation=portrait",
  },
  {
    id: "f18",
    title: "边境旅馆",
    year: 2024,
    region: "西班牙",
    genre: "社会现实",
    rating: 8.9,
    duration: "134 分钟",
    director: "卡洛斯·门",
    cast: ["露西亚·加", "迭戈·费", "玛尔塔·雷"],
    tags: ["迁徙", "旅馆", "过客"],
    views: "87.5 万",
    summary: "一座开在两国边境的旧旅馆，收留过无数准备越界的人。老板娘守着这栋房子，也守着一个关于自己女儿的、永远不会寄出的地址。",
    cover: "https://readdy.ai/api/search-image?query=a%20weathered%20border%20town%20inn%20at%20sunset%20with%20warm%20windows%20and%20distant%20hills%20cinematic%20film%20still%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20dramatic%20rim%20light%2C%20moody%20blurred%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=ethilmic-18&orientation=portrait",
  },
];

export const filmRegions: string[] = ["全部", "中国", "日本", "韩国", "法国", "意大利", "北欧", "西班牙"];